import styled from "styled-components";


export const CarouselSection = styled.section`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding: clamp(18px, 2.4vw, 32px) 0 4px;
`;

export const PatternLayer = styled.div`
  position: absolute;
  inset: 0;
  opacity: 0.12;

  // background-image: repeating-linear-gradient(
  //   45deg,
  //   transparent,
  //   transparent 40px,
  //   rgba(255, 255, 255, 0.4) 40px,
  //   rgba(255, 255, 255, 0.3) 48px
  // );
`;

export const CarouselContainer = styled.div`
  overflow: hidden;
  width: min(1200px, calc(100% - 180px));
  margin: auto;
  position: relative;

  @media (max-width: 900px) {
    width: calc(100% - 40px);
  }
`;

export const CarouselTrack = styled.div`
  display: flex;
  transform: translateX(-${({ $slideNo = 0 }) => $slideNo * 100}%);
  transition: transform 0.7s ease-in-out;
`;

export const SlideGrid = styled.div`
  flex: 0 0 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(28px, 5vw, 80px);
  align-items: center;
  min-width: 0;

  > div:first-child {
    min-width: 0;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
    text-align: center;
  }
`;
export const SlideTitle = styled.h2`
  font-size: clamp(28px, 3.2vw, 42px);
  line-height: 1.1;
  font-weight: 700;

  color: #173f86;
`;

export const SlideDescription = styled.p`
  margin-top: clamp(14px, 2vw, 28px);
  font-size: clamp(16px, 1.7vw, 22px);
  line-height: 1.4;
  color: #173f86;
  overflow-wrap: anywhere;
`;

export const ImageCard = styled.div`
  border: none;
  border-radius: 0;
  overflow: hidden;
  width: 100%;
  height: auto;
  background: transparent;
  box-shadow: none;
  padding: 0;
  margin: 0;

  img {
    display: block;
    width: 100%;
    height: auto;
    max-width: 100%;
    object-fit: contain;
    object-position: center;
    image-rendering: auto;
    border: none;
    border-radius: 0;
    outline: none;
    box-shadow: none;
  }

  @media (max-width: 768px) {
    border-radius: 0;
  }
`;

export const ArrowLeft = styled.button`
  position: absolute;
  top: 50%;
  left: 0;
  width: clamp(44px, 5vw, 80px);
  height: clamp(100px, 17vw, 240px);
  transform: translateY(-50%);
  cursor: pointer;
  border-radius: 0 60px 60px 0;
  background: #f7e2a7;
  display: flex;
  justify-content: center;
  align-items: center;
  /* z-index: 10; */

  svg {
    width: clamp(32px, 4vw, 70px);
    height: auto;
  }

  @media (max-width: 900px) {
    top: 68%;
    width: 38px;
    height: 76px;
  }
`;

export const ArrowRight = styled.button`
  position: absolute;
  cursor: pointer;
  right: 0;
  top: 50%;
  width: clamp(44px, 5vw, 80px);
  height: clamp(100px, 17vw, 240px);
  transform: translateY(-50%);
  border-radius: 60px 0 0 60px;
  background: #f7e2a7;
  display: flex;
  justify-content: center;
  align-items: center;
  /* z-index: 10; */

  svg {
    width: clamp(32px, 4vw, 70px);
    height: auto;
  }

  @media (max-width: 900px) {
    top: 68%;
    width: 38px;
    height: 76px;
  }
`;

export const CarouselDots = styled.div`
  width: max-content;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;

  margin-top: clamp(14px, 2vw, 20px);
  margin-bottom: clamp(14px, 2vw, 18px);

  position: relative;
  z-index: 5;

  @media (max-width: 640px) {
    gap: 8px;
    margin-top: 16px;
  }
`;

export const Dot = styled.button`
  width: ${({ active }) => (active ? "32px" : "12px")};
  height: 12px;

  border: none;
  border-radius: 999px;
  cursor: pointer;

  background: ${({ active }) => (active ? "#173F86" : "#4a6496")};

  transition: all 0.3s ease;

  &:hover {
    background: #173f86;
  }

  @media (max-width: 640px) {
    width: ${({ active }) => (active ? "24px" : "10px")};
    height: 10px;
  }
`;
